import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../interfaces/app-state';
import { HttpService } from '../../services/http/http.service';
import { BasePageComponent } from '../base-page';
import { Router } from '@angular/router';

@Component({
  selector: 'page-404',
  templateUrl: './page-404.component.html',
  styleUrls: ['./page-404.component.scss']
})
export class Page404Component extends BasePageComponent implements OnInit, OnDestroy {
  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    private router:Router
  ) {
    super(store, httpSv);

    this.pageData = {
      title: 'Page not found!',
      loaded: true,
      breadcrumbs: [
        {
          title: 'Dashboard',
          route: 'default-dashboard'
        },
        {
          title: 'Error!'
        }
      ]
    };
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
  Onback(){
    this.httpSv.logout().subscribe(
      response => {
        if (response['status'] == true) {
          this.router.navigate(['/public/sign-in']);
        }
      },
      err => {
        console.log(err);
      }
    );
}
  
}
